import React, { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import userApi from '_api/user'
import reportApi from '_api/report'
import Password from '_components/Password'

const SecurityTab = () => {
  const { addToast } = useToasts()
  const [isLoading, setIsLoading] = useState(false)
  const [firstPin, setFirstPin] = useState(new Array(4))
  const [secondPin, setSecondPin] = useState(new Array(4))
  const [pinErrorMessage, setPinErrorMessage] = useState('')

  const onPinChangedFirst = (pinEntry, index) => {
    const newPin = [...firstPin]
    newPin[index] = pinEntry
    setFirstPin(newPin)
    if (pinErrorMessage) setPinErrorMessage('')
  }

  const onPinChangedSePIN = (pinEntry, index) => {
    const newPin = [...secondPin]
    newPin[index] = pinEntry
    setSecondPin(newPin)
    if (pinErrorMessage) setPinErrorMessage('')
  }

  const clearState = () => {
    setFirstPin(new Array(4))
    setSecondPin(new Array(4))
    setPinErrorMessage('')
  }

  const validatePIN = (first, second) => {
    if (!first || first.some((item) => item === undefined) || first[0] === undefined) {
      setPinErrorMessage('Invalid PIN. Please enter all 4 digits.')
      return false
    }
    if (!second || second.some((item) => item === undefined) || second[0] === undefined) {
      setPinErrorMessage('Please re-confirm your 4-digit PIN.')
      return false
    }
    const isValid =
      first.length === second.length &&
      first.every((value, index) => value === second[index])

    if (!isValid) {
      setPinErrorMessage('PIN and Confirm PIN do not match!')
      return false
    }

    setPinErrorMessage('')
    return true
  }

  const onSubmit = () => {
    const isValid = validatePIN(firstPin, secondPin)
    if (!isValid) return

    setIsLoading(true)
    userApi
      .changePassword({ newPassword: firstPin.join(''), oldPassword: 'aaaa' })
      .then(({ msgCode }) => {
        if (msgCode % 100 === 0) {
          addToast('PIN updated successfully', { appearance: 'success', autoDismiss: true })
          clearState()
        }
        setIsLoading(false)
      })
      .catch((error) => {
        const msgResp = error?.msgResp || 'Failed to update PIN'
        const msgCode = error?.msgCode || ''
        reportApi.report({ message: `[Change password 01]${msgCode} - ${msgResp}` })
        addToast(msgResp, { appearance: 'error', autoDismiss: true })
        setIsLoading(false)
      })
  }

  return (
    <div className='tab-security-view'>
      <div className='section-card'>
        <div className='section-hd'>
          <div className='section-title'>
            <svg
              width='15'
              height='15'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <rect x='3' y='11' width='18' height='11' rx='2' ry='2' />
              <path d='M7 11V7a5 5 0 0 1 10 0v4' />
            </svg>
            Change PIN
          </div>
        </div>

        <div className='security-content'>
          <div className='security-desc'>
            Update your 4-digit security PIN used for sign-in.
          </div>

          {pinErrorMessage && (
            <div className='security-error'>
              <svg
                width='14'
                height='14'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <circle cx='12' cy='12' r='10' />
                <line x1='12' y1='8' x2='12' y2='12' />
                <line x1='12' y1='16' x2='12.01' y2='16' />
              </svg>
              <span>{pinErrorMessage}</span>
            </div>
          )}

          <div className='security-pin-group'>
            <label className='field-label'>New 4-Digit PIN</label>
            <Password
              isFirstPin={true}
              pinLength={4}
              onPinChanged={onPinChangedFirst}
              pin={firstPin}
            />
          </div>

          <div className='security-pin-group'>
            <label className='field-label'>Confirm New PIN</label>
            <Password
              pinLength={4}
              onPinChanged={onPinChangedSePIN}
              pin={secondPin}
            />
          </div>

          <div className='security-actions'>
            <button
              type='button'
              className='cancel-btn'
              onClick={clearState}
              disabled={isLoading}
            >
              Clear
            </button>
            <button
              type='button'
              className='save-btn'
              onClick={onSubmit}
              disabled={isLoading}
            >
              {isLoading ? 'Updating...' : 'Update PIN'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SecurityTab
